export const HIST_NOTIFICATIONS = "HIST_NOTIFICATIONS"; // First Time with sockets connection estlasblished
export const READ_NOTIFICATIONS = "READ_NOTIFICATIONS"; // Notifcation read by someone
export const NEW_NOTIFICATION = "NEW_NOTIFICATION"; // New Notification received stored in notification list
export const MESSAGE = "MESSAGE"; // Receive new notication, but notification will not store
export const NOTIFICATION_CONSTANTS = {
  GET_TOKEN_FOR_WEBSOCKET_SUCCESS: "GET_TOKEN_FOR_WEBSOCKET_SUCCESS",
};
export const TENANT_CREATION_STATUS_SUCCESS_FROM_SOCKET =
  "Die Datei wurde bearbeitet. Bitte aktualisieren Sie die Webseite.";
  
export const CSV_IMPORT_PROCESSED = "CSV_IMPORT_PROCESSED";
